/**
 * ImageSupport is used to determine if a file's content type can be displayed
 * as an image within a browser.
 */

const TYPES: { [key: string]: boolean } = {
  'image/bmp': true,
  'image/gif': true,
  'image/jpeg': true,
  'image/png': true,
  'image/webp': true,
};

export function isSupportedType(contentType: string): boolean {
  return contentType in TYPES ? TYPES[contentType] : false;
}
